import { render } from "./DescListView.vue?vue&type=template&id=40c18bb7"
import script from "./DescListView.vue?vue&type=script&lang=js"
export * from "./DescListView.vue?vue&type=script&lang=js"

import "./DescListView.vue?vue&type=style&index=0&id=40c18bb7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__